import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideArrowUp = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m5 12 7-7 7 7m-7 7V5"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideArrowUp);
const Memo = memo(ForwardRef);
export default Memo;
